export default "__VITE_ASSET__DonsY6FG__"